export const poetryFormsPool = [
    {
      poem: "Shall I compare thee to a summer's day?\nThou art more lovely and more temperate...",
      form: "Sonnet",
      distractors: ["Haiku", "Free Verse", "Limerick"]
    },
    {
      poem: "An old silent pond...\nA frog jumps into the pond,\nsplash! Silence again.",
      form: "Haiku",
      distractors: ["Sonnet", "Limerick", "Ballad"]
    }
  ];
  